import OrmModel from '~/models/abstracts/base/OrmModel'

export default class Directory extends OrmModel {

}
